// Material Kit 2 React components
import MKBox from "components/MKBox";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import DefaultFooter from "components/Footers/DefaultFooter";
import { Container, Grid } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/teatro1.png";

function AboutUs() {
  return (
    <>
      <DefaultNavbar routes={routes} light />
      <MKBox
        minHeight="50vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.2),
              rgba(gradients.dark.state, 0.2)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox component="section" bgColor="white" py={4}>
        <Container>
          <Grid container spacing={1} item xs={12} lg={12} mx="auto">
            <Grid item xs={4}>
              <Breadcrums
                routes={[
                  { label: "Inicio", route: "/" },
                  { label: "Acerca de ", route: "/" },
                  { label: "Nosotros", route: "#" },
                  { label: "Acerca de Nosotros", route: "#" },
                ]}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <Container>
        <MKBox p={3} position="relative">
          <Grid
            container
            item
            xs={12}
            lg={12}
            justifyContent="left"
            sx={{ mx: "auto", textAlign: "left" }}
          >
            <MKTypography variant="h3" color="inherit" style={{ fontSize: "35px" }}>
              Acerca de Nosotros
            </MKTypography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            lg={12}
            justifyContent="left"
            sx={{ mx: "auto", textAlign: "left" }}
          >
            <MKTypography variant="body2" color="text" mb={2} style={{ fontSize: "18px" }}>
              Revitalización del Centro Histórico de San Miguel
            </MKTypography>
          </Grid>
          <br />
          <MKTypography variant="h3" color="inherit" mb={2}>
            Descripción
          </MKTypography>
          <MKTypography
            variant="body2"
            color="text"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            Este espacio ha sido posible gracias a la donación de la Agencia de los Estados Unidos
            para el Desarrollo Internacional (USAID) en el marco del Proyecto denominado
            Gobernabilidad Municipal. La Universidad Gerardo Barrios (UGB) a través de la
            Vicerrectoría de Investigación y Proyección Social, ejecuta la iniciativa denominada{" "}
            <b>
              “Revitalización del Centro Histórico de San Miguel a través de Herramientas
              Tecnológicas”.
            </b>{" "}
            El propósito de esta iniciativa es generar información de condiciones e inteligencia de
            negocios para apoyar la identificación de oportunidades e inversión para los distintos
            agentes económicos interesados en hacer negocios en el Centro Histórico de San Miguel, a
            través del desarrollo de herramientas de información y comunicaciones.
          </MKTypography>
          <br />
          <br />
          <MKTypography variant="h3" color="inherit" mb={2}>
            Objetivo General
          </MKTypography>
          <MKTypography
            variant="body2"
            color="text"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            Desarrollar herramientas de tecnología de información y comunicaciones para generar
            información de condiciones e inteligencia de negocios para los distintos agentes
            económicos interesados en invertir en el Centro Histórico de San Miguel, y contribuir
            así a su revitalización socioeconómica.
          </MKTypography>
          <br />
          <br />
          <MKTypography variant="h3" color="inherit" mb={2}>
            Objetivos Específicos
          </MKTypography>
          <MKTypography
            variant="body2"
            color="text"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul style={{ marginLeft: "10px" }}>
              <li>
                <b>Generar Información de Inteligencia de Negocios</b>, para promover la atracción
                de inversiones en desarrollo inmobiliario y creación de establecimientos comerciales
                en el Centro Histórico de San Miguel y sus alrededores.
              </li>
              <li>
                <b>Generar Información del Sector de Vendedores en la Vía Pública</b>, para mejorar
                políticas y estrategias de localización de vendedores en la vía pública y el
                desarrollo progresivo de este sector para promover una apropiada integración a la
                economía de la ciudad.
              </li>
              <li>
                <b>Transferencia de conocimientos y desarrollo de capacidades a la municipalidad</b>
                , emprendedores y organizaciones de sociedad civil del Centro Histórico de San
                Miguel sobre inteligencia de negocios, diversificación económica y gestión del
                sector informal.
              </li>
            </ul>
          </MKTypography>
          <br />
          <br />
          <MKTypography variant="h3" color="inherit" mb={2}>
            Periodo del Proyecto
          </MKTypography>
          <MKTypography
            variant="body2"
            color="text"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            La fecha efectiva de desarrollo de la iniciativa es a partir del 8 de octubre de 2021.
            La fecha para la finalización es el 31 de octubre de 2022.
          </MKTypography>
        </MKBox>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
